// Dans un fichier constants.js
export const SEXE_OPTIONS = [
  { value: "M", label: "MASCULIN" },
  { value: "F", label: "FÉMININ" },
];
